import type { AxiosResponse } from 'axios'
import type { ListQuery, Page } from '@shared/domain/types'

export interface PageMeta {
  page: number
  size: number
  totalElements: number
  totalPages: number
  sort?: string
  direction?: string
}

/** The backend wraps every body as `{ success, data, page?, error?, timestamp }`. */
export interface ApiEnvelope<T> {
  success: boolean
  data: T
  message?: string
  page?: PageMeta
  timestamp?: string
}

export const unwrap = <T>(res: AxiosResponse<ApiEnvelope<T>>): T => res.data.data

/** A list endpoint's envelope (0-based `page` meta) → the app's 1-based Page. */
export function unwrapPage<T>(res: AxiosResponse<ApiEnvelope<T[]>>): Page<T> {
  const { data, page } = res.data
  return {
    items: data,
    page: (page?.page ?? 0) + 1,
    size: page?.size ?? data.length,
    total: page?.totalElements ?? data.length,
  }
}

/** The app's list query (1-based page, `sort=field,dir`) → backend params (0-based page). */
export function toBackendQuery({ page, size, sort, ...filters }: ListQuery) {
  const [field, direction] = sort?.split(',') ?? []
  return {
    ...filters,
    page: page - 1,
    size,
    sort: field || undefined,
    direction: field ? direction : undefined,
  }
}
